const wxBind = {
  path: 'wxBind',
  component: resolve => require(['../../../../pages/home/user/wx-bind'], resolve)
}

export default wxBind
